<template>
<div>
    <Breadcrumbs main="Fulfillment" title="Planning" />

    <div class="container-fluid">

        <!-- HEADER + STATS -->
        <div class="row">
            <div class="col-12">
                <div class="card mb-3">
                    <div class="card-body">

                        <!-- Header -->
                        <div class="d-flex justify-content-between align-items-center flex-wrap mb-3">
                            <div>
                                <h4 class="mb-1">Fulfillment Planning</h4>
                                <small class="text-muted">
                                    Route-first planning instead of dense delivery tables.
                                </small>
                            </div>

                            <div class="d-flex mt-2 mt-md-0" style="gap: 8px;">
                                <b-button variant="light">Assign route</b-button>
                                <b-button variant="dark" v-b-modal.challan-create-modal>Create batch</b-button>
                            </div>
                        </div>

                        <!-- Stats -->
                        <div class="row g-2">
                            <div class="col-6 col-sm-4 col-md-2" v-for="stat in stats" :key="stat.label">
                                <div class="card h-100 stat-card">
                                    <div class="card-body px-3 py-2">
                                        <small class="text-muted">{{ stat.label }}</small>
                                        <h6 class="mb-0">{{ stat.value }}</h6>
                                        <small class="text-muted">{{ stat.sub }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <!-- MAIN CONTENT -->
        <div class="row g-3">

            <!-- LEFT SIDE -->
            <div class="col-md-12">
                <div class="card h-100">

                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h5 class="mb-0">Dispatch Planning Board</h5>

                        <b-input-group size="sm" style="max-width: 250px;">
                            <b-form-input v-model="filter" placeholder="Search"></b-form-input>
                            <b-input-group-append>
                                <b-button size="sm" @click="filter = ''" :disabled="!filter">
                                    Clear
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </div>

                    <div class="card-body p-2">

                        <b-table show-empty :items="items" borderless filter-debounce="500" responsive   :fields="tablefields" :per-page="perPage" :current-page="currentPage" :filter="filter" @filtered="onFiltered" class="dispatch-table" small>
                            <template #cell(index)="data">
                                <div class="dispatch-index">
                                    {{ (currentPage - 1) * perPage + data.index + 1 }}
                                </div>
                            </template>

                            <template #cell(challan)="data">
                                <div>
                                    <div class="fw-bold">{{ data.item.challan_id }}</div>
                                    <small class="text-muted" v-if="data.item?.client?.first_name">{{ data.item?.client?.first_name }}</small>
                                </div>
                            </template>

                            <template #cell(amount)="data">
                                <strong>৳ {{ data.item?.invoice?.total }}</strong>
                            </template>

                            <template #cell(status)="data">
                                <b-badge :variant="statusVariant(data.item.delivery_status)" class="text-uppercase">
                                    {{ data.item.delivery_status }}
                                </b-badge>
                            </template>
                            <template #cell(location)="data">
                                <small>{{ data.item?.delivery_address }}</small>
                            </template>

                            <template #cell(action)="data">
                                <div class="d-flex align-items-center  action-group" style="gap: 10px;">

                    
                                    <!-- <b-button size="sm" variant="outline-primary" class="d-flex align-items-center px-2" @click="selectBatch(data.item)">
                                        <feather type="clipboard" size="14" class="mr-1"></feather>
                                        Plan
                                    </b-button> -->
                                    <feather type="delete" size="18px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteChallan(data.item.id)" title="Delete"></feather>

                                </div>
                            </template>

                        </b-table>

                        <!-- Pagination -->
                        <div class="d-flex justify-content-between align-items-center mt-2 px-2">
                            <b-form-select v-model="perPage" :options="pageOptions" size="sm" style="width: 100px;"></b-form-select>

                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" size="sm"></b-pagination>
                        </div>

                    </div>
                </div>
            </div>

            <!-- RIGHT SIDE -->
            <!-- <div class="col-md-4">
                <div class="card h-100">
                    <div class="card-body">

                        <h6 class="mb-3">Selected batch</h6>

                        <div class="bg-light p-2 rounded mb-3">
                            <strong>{{ selectedBatch?.id || 'Select an order' }}</strong>
                        </div>

                        <div v-if="selectedBatch">
                            <div class="d-flex justify-content-between mb-1">
                                <small>Route</small>
                                <small>{{ selectedBatch.route }}</small>
                            </div>

                            <div class="d-flex justify-content-between mb-1">
                                <small>Vehicle</small>
                                <small>{{ selectedBatch.vehicle }}</small>
                            </div>

                            <div class="d-flex justify-content-between mb-1">
                                <small>Stops</small>
                                <small>{{ selectedBatch.stops }}</small>
                            </div>

                            <div class="mt-2">
                                <small>Load Progress</small>
                                <b-progress :value="selectedBatch.progress" height="6px"></b-progress>
                            </div>

                            <div class="alert alert-danger mt-3 p-2" v-if="selectedBatch.blocked">
                                {{ selectedBatch.blocked }}
                            </div>
                        </div>

                    </div>
                </div>
            </div> -->

        </div>
    </div>
        <!-- Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this Challan?</div>
    </b-modal>
    <!-- Batch create -->
    <b-modal id="challan-create-modal" size="lg" ref="modal" title="Create Batch" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group label="Vehicle" label-for="name-input" invalid-feedback="Item is required">
                <b-form-input id="name-input" v-model="batchItem.vehicle" placeholder="Enter vehicle Name"></b-form-input>
            </b-form-group>


            <div class="form-group">
                <label>Route</label>
                <v-select  class="custom-vue-select" :options="route_list" label="name" :reduce="t => t.id" v-model="batchItem.route" placeholder="Select a route"></v-select>
            </div>
            

            <div class="form-group">
                <label>Challan</label>
                <multiselect v-model="selectedChallans" tag-placeholder="" placeholder="Search challan" label="challan_id" :max="items.length" track-by="id"  :options="items" :multiple="true" :taggable="true"></multiselect>
            </div>

            <b-form-group label="Remarks" label-for="name-input" invalid-feedback="Item is required">
                <b-form-input id="name-input" v-model="batchItem.remarks" placeholder="Enter remarks here.."></b-form-input>
            </b-form-group>



        </form>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Multiselect from 'vue-multiselect';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
export default {
    components: {
        'v-select': vSelect,
        Multiselect
    },
    data() {
        return {

            tablefields: [{
                    key: 'index',
                    label: ''
                },
                {
                    key: 'challan',
                    label: ''
                },
                {
                    key: 'location',
                    label: ''
                },
                {
                    key: 'amount',
                    label: ''
                },
                {
                    key: 'status',
                    label: ''
                },
                {
                    key: 'action',
                    label: ''
                }
            ],
            stats: [{
                    label: 'READY',
                    value: 42,
                    sub: 'Waiting for dispatch'
                },
                {
                    label: 'SCHEDULED',
                    value: 17,
                    sub: 'Assigned to batches'
                },
                {
                    label: 'BLOCKED',
                    value: 6,
                    sub: 'Requires resolution'
                },
                {
                    label: 'PARTIAL',
                    value: 13,
                    sub: 'Split fulfillment'
                },
                {
                    label: 'IN DISPATCH',
                    value: 9,
                    sub: 'Active today'
                }
            ],

            selectedBatch: null,

            totalRows: 0,
            currentPage: 1,
            perPage: 5,
            pageOptions: [5, 10, 20],

            filter: '',
            delete_value: null,
            batchItem:{
                route: null,
                vehicle: null,
                remarks: '',
                challans:[]
            },
            selectedChallans: []
        }
    },
    computed: {
        ...mapState({
            items: state => state.order.sales_fulfillment,
            // count: state => state.invoice.invoice_count,
            loading: state => state.order.submitLoading,
            error: state => state.order.submitError,
            route_list: state => state.territory.route,

        }),
    },
    mounted() {
        this.fetchInitialFulfillment()
        this.$store.dispatch("territory/fetchRoute")
        // this.totalRows = this.items.length
    },

    methods: {
        resetModal() {
            this.batchItem.route = null
            this.batchItem.vehicle = null
            this.batchItem.remarks = ''
            this.batchItem.challans = []
            this.selectedChallans = []
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },
        handleSubmit(){
            if(this.selectedChallans?.length > 0) {
                this.selectedChallans.map(item => {
                    this.batchItem.challans.push(item.id)
                })
            }
            this.$store.dispatch("order/challanBatchCreate", this.batchItem).then(response => {
              
                if (response.code == 201) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.selectedChallans = []
                
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            this.$nextTick(() => {
                this.$bvModal.hide('challan-create-modal')
            })
        },
       


        fetchInitialFulfillment() {
            this.$store.dispatch("order/fetchFulfillment", {
                // perPage: this.perPage,
                // currentPage: this.currentPage,
                // start_date: this.start_date,
                // end_date: this.end_date,
                // search_term: this.filter,
                // status: this.status,
                // client: this.client,
                // project: this.project,
                // employee: this.selectedEmployee
            }).then((response) => {
                this.totalRows = response.data.length;
                // this.initialLoad = false;
            });
        },

        statusVariant(status) {
            if (status === 'READY') return 'success'
            if (status === 'BLOCKED') return 'danger'
            if (status === 'PARTIAL') return 'warning'
            return 'secondary'
        },

        selectBatch(item) {
            this.selectedBatch = {
                id: 'DB-1104',
                route: item.location,
                vehicle: 'Truck 03',
                stops: '7 customers',
                progress: 68,
                blocked: item.status === 'BLOCKED' ?
                    'Order blocked due to payment or address issue' : ''
            }
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        deleteChallan(id) {
            this.delete_value = id
        },
        handleDeleteOk() {
            this.$store.dispatch("order/deleteChallan", {
                id: this.delete_value,
                currentPage: this.$route.query.page,
                perPage: this.$route.query.perPage,
                start_date: this.start_date,
                end_date: this.end_date,
                search_term: this.filter,
                status: this.status,
                client: this.client,
                project: this.project,
                employee: this.selectedEmployee
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },
    }
}
</script>

<style>
.dispatch-table tbody tr td {
    padding: 10px 8px !important;
    vertical-align: middle;
}

.dispatch-index {
    width: 32px;
    height: 32px;
    background: #f1f3f5;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
}

.stat-card {
    border: 1px solid #eee;
    border-radius: 10px;
}

.action-group {
    gap: 6px;
    /* tighter than Bootstrap default */
}

.action-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    color: #495057;
    transition: all 0.2s ease;
}

.action-icon:hover {
    background-color: #f8f9fa;
    color: #0d6efd;
    border-color: #0d6efd;
}

</style>
